























































import Vue from "vue";
import SmallTable, { Header, Action } from "@/components/ui/SmallTable.vue";
import { Dokument, Kategorie, UploadDokument } from "@/types";
import { erklServiceInstance } from "@/services/ErklService";
import AlertService from "@/services/libs/AlertService";
import { kommunenServiceInstance } from "@/services/KommunenService";
import SaveDialog from "@/components/dialog/SaveDialog.vue";
import UploadDialog from "@/components/dialog/UplaodDialog.vue";
import LoadingScreen from "@/components/dialog/LoadingScreen.vue";
import { alertError } from "@/services/ErrorAlert";
import { RequestError } from "@/services/AuthService";

export default Vue.extend({
  name: "DocumentsTab",
  components: {
    SmallTable,
    UploadDialog,
    SaveDialog,
    LoadingScreen,
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      isLoading: false,
      isUploading: false,
      isDownloading: false,
      uploadProgress: undefined as undefined | number,
      downloadProgress: undefined as undefined | number,
      documents: [] as Dokument[],
      categories: [] as Kategorie[],
      openUploadDialog: false,
      openSaveDialog: false,
      newDokument: {} as UploadDokument,
      documentActions: [
        {
          title: "Dokument Öffnen",
          type: "is-primary",
          icon: "download",
          public: true,
          f: (d: any): void => (this as any).openDokument(d),
        },
      ] as Action[],
    };
  },
  computed: {
    tableDocumentsHeader(): Header[] {
      return [
        { field: "bezeichnung", label: "Bezeichnung" },
        {
          field: "kategorie",
          label: "Kategorie",
          display: (item: Dokument): String => item?.bez || "-",
          type: "select",
          placeholder: "auswhählen",
          options: this.categories,
          sortable: true,
        },
        {
          field: "kurzbeschreibung",
          label: "Kurzbeschreibung",
          type: "textarea",
          maxlength: 2000,
          sortable: true,
        },
        {
          field: "filesize",
          type: "filesize",
          label: "Größe",
          readonly: true,
          sortable: true,
          numeric: true,
        },
        { field: "autor", label: "Autor", readonly: true, sortable: true },
        {
          field: "datum",
          label: "Datum",
          type: "date",
          readonly: true,
          sortable: true,
        },
      ] as Header[];
    },
  },
  mounted() {
    this.isLoading = true;
    Promise.all([
      erklServiceInstance
        .getKategorien()
        .then((data: Kategorie[]) => (this.categories = data)),

      kommunenServiceInstance
        .getDokumente(this.id)
        .then((data: Dokument[]) => (this.documents = data)),
    ])
      .then(() => this.$emit("loaded", this.documents))
      .catch((error: any) => alertError(error))
      .finally(() => (this.isLoading = false));
  },
  methods: {
    onUpload(document: UploadDokument) {
      this.openUploadDialog = true;
      this.newDokument = document;
    },
    onUploadConfirm(document: UploadDokument) {
      if (!document.file) {
        AlertService.warning(
          "Upload ungültig!",
          "Es muss eine Datei ausgewählt werden.",
        );
        return;
      }
      // delete existing concept
      this.isUploading = true;
      kommunenServiceInstance
        .uploadDokument(
          this.id,
          document,
          (e: any) => (this.uploadProgress = (e.loaded / e.total) * 100),
        )
        .then((document: Dokument) => {
          // add new document to list
          this.documents.unshift(document);
          // clear newDokument object
          this.newDokument = {} as UploadDokument;
          AlertService.info("Dokument hochgeladen!");
        })
        .catch((error: RequestError) =>
          AlertService.error(
            "Beim Hochladen des Dokuments ist ein Fehler aufgetreten!",
            "Bitte versuchen Sie es in einiger Zeit erneut!",
            "Wenn das Problem weiterhin besteht, informieren Sie bitte den Helpdesk!",
            "Fehlermeldung: " + error.message,
          ),
        )
        .finally(() => {
          this.isUploading = false;
          this.uploadProgress = undefined;
        });
    },
    onUploadCancel() {
      // remove new document from list
      const index = this.documents.findIndex(
        (el: any) => el.id == (this.newDokument as any)?.id,
      );
      if (index != -1) this.documents.splice(index, 1);

      // clear newDokument object
      this.newDokument = {} as UploadDokument;
    },
    onSaveConfirm() {
      this.isLoading = true;
      kommunenServiceInstance
        .updateDokumente(this.id, this.documents)
        .then((data: Dokument[]) => {
          this.documents = data;
          AlertService.info("Vorsorgekonzept gespeichert!");
        })
        .catch((error: RequestError) =>
          AlertService.error(
            "Beim Speichern der Dokumente ist ein Fehler aufgetreten!",
            "Bitte versuchen Sie es in einiger Zeit erneut!",
            "Wenn das Problem weiterhin besteht, informieren Sie bitte den Helpdesk!",
            "Fehlermeldung: " + error.message,
          ),
        )
        .finally(() => (this.isLoading = false));
    },
    openDokument(dokument: Dokument) {
      this.isDownloading = true;
      kommunenServiceInstance
        .openDokument(
          this.id,
          dokument,
          (e: any) => (this.downloadProgress = (e.loaded / e.total) * 100),
        )
        .catch((error: RequestError) =>
          AlertService.error(
            "Beim Öffnen des Dokuments ist ein Fehler aufgetreten!",
            "Bitte versuchen Sie es in einiger Zeit erneut!",
            "Wenn das Problem weiterhin besteht, informieren Sie bitte den Helpdesk!",
            "Fehlermeldung: " + error.message,
          ),
        )
        .finally(() => {
          this.isDownloading = false;
          this.downloadProgress = undefined;
        });
    },
  },
});
